import { FC } from 'react';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { exportPdf } from '@/utils/exportPdf';
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';
import { TableData } from '../Table/types';
import styles from './PrintButton.module.scss';

type PrintButtonProps = {
  data: TableData;
  isDisabled?: boolean;
  columnsToExport?: string[];
  fileName?: string;
};

const PrintButton: FC<PrintButtonProps> = ({
  data,
  isDisabled,
  columnsToExport,
  fileName,
}) => {
  const { t } = useTranslation('table');
  const onClick = () => {
    exportPdf({
      data,
      fileName,
      selectedColumns: columnsToExport,
    });
  };
  return (
    <Button
      secondary
      disabled={isDisabled}
      className={styles.printButton}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faPrint} />
      {t('print')}
    </Button>
  );
};

export default PrintButton;
